import { RequiredSnippetStatus, RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { InboxFilter_Accepted, InboxFilter_Completed, InboxFilter_InputRequired, InboxFilter_Pending, InboxFilter_Resulted } from './types.js';
export const orderStatusMatchesInboxFilter = (status, activeFilters) => {
    if (!activeFilters.length)
        return true;
    switch (status) {
        case RuntimeOrderStatus_Enum.PENDING_SIGNATURE:
        case RuntimeOrderStatus_Enum.PENDING:
            return activeFilters.includes(InboxFilter_Pending);
        case RuntimeOrderStatus_Enum.RESULTED:
            return activeFilters.includes(InboxFilter_Resulted);
        case RuntimeOrderStatus_Enum.COMPLETED:
            return activeFilters.includes(InboxFilter_Completed);
        case RuntimeOrderStatus_Enum.ACCEPTED:
            return activeFilters.includes(InboxFilter_Accepted);
        default:
            return true;
    }
};
export const wizardStatusMatchesInboxFilter = (status, activeFilters) => {
    if (!activeFilters.length)
        return status !== RequiredSnippetStatus.FULFILLED;
    switch (status) {
        case RequiredSnippetStatus.INCOMPLETE: {
            return activeFilters.includes(InboxFilter_InputRequired);
        }
        case RequiredSnippetStatus.FULFILLED: {
            return activeFilters.includes(InboxFilter_Completed);
        }
        default:
            return true;
    }
};
//# sourceMappingURL=utils.js.map